import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import App from './App';

import './i18n';

import './index.scss';
import { persistor, store } from './store';
import './features/common/utils/logger';

// Expose the store in development so Cypress can read context state and write
// pksCtx to localStorage, preventing the /select-profile redirect after cy.visit().
if (import.meta.env.DEV) {
    (globalThis as any).__store = store;
}

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    );
}
